import React from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  CardText,
  CardSubtitle,
  CardImg
} from "reactstrap";
function CardItem(props) {
  if (props.items && props.items.length > 0) {
    return (
      <Row>
        {props.items.map((c, index) => (
          <Col key={index} xs={12} sm={12} md={12} lg={12}>
            <Card key={index}>
              <Row className="no-gutters">
                <Col md={2}>
                  <div>
                    <CardImg
                      className="img-thumbnail img-thumbnail-all mx-auto d-block"
                      src={`${c.url_caratula}`}
                      alt="Portada de publicación"
                    />
                  </div>
                </Col>
                <Col md={10}>
                  <CardBody>
                    <CardTitle>
                      <p className="text-muted text-left">
                        {c.tipo}
                      </p>
                    </CardTitle>
                    <CardSubtitle>
                      <a
                        href={`${c.url_sinia}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p className="text-secondary font-weight-bold text-left " title={c.nombre}>
                          {c.nombre}
                        </p>
                      </a>
                    </CardSubtitle>
                    <CardText title={c.fuente} className=" text-muted text-left text-short-preview">
                      {c.fuente}
                    </CardText>
                    <CardText className="text-left text-secondary">
                      {c.fecha_mes} {c.fecha_anio}
                    </CardText>
                    <CardText className="text-left">
                      {" "}
                      <a
                        href={`${c.url_sinia}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-primary btn-sm"
                      >
                        Leer más
                      </a>
                    </CardText>
                  </CardBody>
                </Col>
              </Row>
              <div className="mt-3 mb-3 card-component-line">
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    )
  } else {
    return (
      <div></div>
    )
  }
}

export default CardItem;
